import { render, staticRenderFns } from "./InformationAboutPhysicalActivityIndicators.vue?vue&type=template&id=b310d43a&"
import script from "./InformationAboutPhysicalActivityIndicators.vue?vue&type=script&lang=js&"
export * from "./InformationAboutPhysicalActivityIndicators.vue?vue&type=script&lang=js&"
import style0 from "./InformationAboutPhysicalActivityIndicators.vue?vue&type=style&index=0&id=b310d43a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports